import { cn } from "@/lib/utils"

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  variant?: 'primary' | 'accent' | 'muted'
}

export function LoadingSpinner({ 
  size = 'md', 
  className,
  variant = 'primary' 
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  }

  const variantClasses = {
    primary: 'border-primary/20 border-t-primary',
    accent: 'border-accent/20 border-t-accent',
    muted: 'border-muted/20 border-t-muted-foreground'
  }

  return (
    <div className={cn("flex items-center justify-center", className)}>
      <div 
        className={cn(
          "animate-spin rounded-full border-2",
          sizeClasses[size],
          variantClasses[variant]
        )}
      />
    </div>
  )
}

interface PulseDotsProps {
  className?: string
  variant?: 'primary' | 'accent' | 'muted'
}

export function PulseDots({ className, variant = 'primary' }: PulseDotsProps) {
  const variantClasses = {
    primary: 'bg-primary',
    accent: 'bg-accent',
    muted: 'bg-muted-foreground'
  }

  return (
    <div className={cn("flex items-center space-x-1", className)}>
      <div 
        className={cn(
          "w-2 h-2 rounded-full animate-pulse",
          variantClasses[variant]
        )}
        style={{ animationDelay: '0ms' }}
      />
      <div 
        className={cn(
          "w-2 h-2 rounded-full animate-pulse",
          variantClasses[variant]
        )}
        style={{ animationDelay: '150ms' }}
      />
      <div 
        className={cn(
          "w-2 h-2 rounded-full animate-pulse",
          variantClasses[variant]
        )}
        style={{ animationDelay: '300ms' }}
      />
    </div>
  )
}